import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import UbicacionFisica from './UbicacionFisica';







interface UbicacionFisicaTableProps {
  data: UbicacionFisica[];
  columns: TableColumn<UbicacionFisica>[];
  customStyles: Record<string, any>;
}

const UbicacionFisicaTable: React.FC<UbicacionFisicaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<UbicacionFisica>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default UbicacionFisicaTable;